export interface TestimonialRespondentFilters {
  page: number;
  perPage: number;
  tagIds: string[];
}

export const testimonialRespondentsMediaQueryKeys = {
  all: ['testimonial-respondents-media'],
  lists: () => [...testimonialRespondentsMediaQueryKeys.all, 'list'] as const,
  list: (filters: TestimonialRespondentFilters) =>
    [...testimonialRespondentsMediaQueryKeys.lists(), { ...filters }] as const,
};
